import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { NycdBusinessCardStackBackgroundViewModel } from './nycd-business-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-nycd-business-card-background',
  templateUrl: './nycd-business-card-stack-background.component.html',
  styleUrls: ['./nycd-business-card-stack-background.component.scss'],
  providers: [NycdBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NycdBusinessCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: NycdBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
